import { defineStore } from 'pinia'

export const useAppSettingsStore = defineStore('appSettingsStore', {
  state: () => ({
    configs: [],
    categories: [],
    activityTypes: [],
    initiatives: [],

    loading: false,
    loaded: false,
    error: null
  }),

  getters: {
    allCategories: (state) =>
      state.categories,
    allActivityTypes: (state) =>
      state.activityTypes,
    activeCategories: (state) =>
      state.categories.filter(c => c.status === 'active'),

    activeActivityTypes: (state) =>
      state.activityTypes.filter(a => a.status === 'active'),

    activeInitiatives: (state) =>
      state.initiatives.filter(i => i.status === 'active')
  },

  actions: {
    // 🔹 Centralised mapper
    loadAllSettings(data) {
      this.configs = data.filter(d => d.type === 'CONFIG') || []
      this.categories = data.filter(d => d.type === 'CONFIG_CATEGORY') || []
      this.activityTypes = data.filter(d => d.type === 'CONFIG_ACTIVITY') || []
      this.initiatives = data.filter(d => d.type === 'CONFIG_INITIATIVE') || []
    },

    // 🔹 Optional: reset (useful on logout)
    reset() {
      this.configs = []
      this.categories = []
      this.activityTypes = []
      this.initiatives = []
      this.loaded = false
      this.error = null
    }
  }
})
